// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file call/call_requests.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type {
  CallPermission_AccessType,
  CallPermission_RequestStatus,
  CallPermissions,
  CallRecording_Type,
  ParticipantIdToRole,
  PersonalizedCallPermissions,
} from './call_model_pb';
import { file_call_call_model } from './call_model_pb';

/**
 * Describes the file call/call_requests.proto.
 */
export const file_call_call_requests: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [file_call_call_model]
  );

/**
 * @generated from message com.gem.bff.contract.JoinToCallRequest
 */
export type JoinToCallRequest = Message<'com.gem.bff.contract.JoinToCallRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;
};

/**
 * Describes the message com.gem.bff.contract.JoinToCallRequest.
 * Use `create(JoinToCallRequestSchema)` to create a new message.
 */
export const JoinToCallRequestSchema: GenMessage<JoinToCallRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 0);

/**
 * @generated from message com.gem.bff.contract.FinishForAllRequest
 */
export type FinishForAllRequest = Message<'com.gem.bff.contract.FinishForAllRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;
};

/**
 * Describes the message com.gem.bff.contract.FinishForAllRequest.
 * Use `create(FinishForAllRequestSchema)` to create a new message.
 */
export const FinishForAllRequestSchema: GenMessage<FinishForAllRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 1);

/**
 * @generated from message com.gem.bff.contract.DeclineCallRequest
 */
export type DeclineCallRequest = Message<'com.gem.bff.contract.DeclineCallRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;

  /**
   * @generated from field: optional string reason = 2;
   */
  reason?: string;
};

/**
 * Describes the message com.gem.bff.contract.DeclineCallRequest.
 * Use `create(DeclineCallRequestSchema)` to create a new message.
 */
export const DeclineCallRequestSchema: GenMessage<DeclineCallRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 2);

/**
 * @generated from message com.gem.bff.contract.KickMemberRequest
 */
export type KickMemberRequest = Message<'com.gem.bff.contract.KickMemberRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;

  /**
   * @generated from field: int64 targetMemberId = 2;
   */
  targetMemberId: bigint;

  /**
   * @generated from field: optional string targetDeviceId = 3;
   */
  targetDeviceId?: string;
};

/**
 * Describes the message com.gem.bff.contract.KickMemberRequest.
 * Use `create(KickMemberRequestSchema)` to create a new message.
 */
export const KickMemberRequestSchema: GenMessage<KickMemberRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 3);

/**
 * @generated from message com.gem.bff.contract.ForceMuteRequest
 */
export type ForceMuteRequest = Message<'com.gem.bff.contract.ForceMuteRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;

  /**
   * @generated from field: int64 targetMemberId = 2;
   */
  targetMemberId: bigint;

  /**
   * @generated from field: optional string targetDeviceId = 3;
   */
  targetDeviceId?: string;
};

/**
 * Describes the message com.gem.bff.contract.ForceMuteRequest.
 * Use `create(ForceMuteRequestSchema)` to create a new message.
 */
export const ForceMuteRequestSchema: GenMessage<ForceMuteRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 4);

/**
 * @generated from message com.gem.bff.contract.GetCallMembersRequest
 */
export type GetCallMembersRequest = Message<'com.gem.bff.contract.GetCallMembersRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message com.gem.bff.contract.GetCallMembersRequest.
 * Use `create(GetCallMembersRequestSchema)` to create a new message.
 */
export const GetCallMembersRequestSchema: GenMessage<GetCallMembersRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 5);

/**
 * @generated from message com.gem.bff.contract.GetCallMembersByCameraOrScreenIdsRequest
 */
export type GetCallMembersByCameraOrScreenIdsRequest =
  Message<'com.gem.bff.contract.GetCallMembersByCameraOrScreenIdsRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: repeated string ids = 2;
     */
    ids: string[];
  };

/**
 * Describes the message com.gem.bff.contract.GetCallMembersByCameraOrScreenIdsRequest.
 * Use `create(GetCallMembersByCameraOrScreenIdsRequestSchema)` to create a new message.
 */
export const GetCallMembersByCameraOrScreenIdsRequestSchema: GenMessage<GetCallMembersByCameraOrScreenIdsRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 6);

/**
 * @generated from message com.gem.bff.contract.GetCallMembersByIdsRequest
 */
export type GetCallMembersByIdsRequest =
  Message<'com.gem.bff.contract.GetCallMembersByIdsRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: repeated int64 ids = 2;
     */
    ids: bigint[];
  };

/**
 * Describes the message com.gem.bff.contract.GetCallMembersByIdsRequest.
 * Use `create(GetCallMembersByIdsRequestSchema)` to create a new message.
 */
export const GetCallMembersByIdsRequestSchema: GenMessage<GetCallMembersByIdsRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 7);

/**
 * @generated from message com.gem.bff.contract.StartCallRecordingRequest
 */
export type StartCallRecordingRequest =
  Message<'com.gem.bff.contract.StartCallRecordingRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: com.gem.bff.contract.CallRecording.Type recordingType = 2;
     */
    recordingType: CallRecording_Type;

    /**
     * @generated from field: optional string title = 3;
     */
    title?: string;
  };

/**
 * Describes the message com.gem.bff.contract.StartCallRecordingRequest.
 * Use `create(StartCallRecordingRequestSchema)` to create a new message.
 */
export const StartCallRecordingRequestSchema: GenMessage<StartCallRecordingRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 8);

/**
 * @generated from message com.gem.bff.contract.StopCallRecordingRequest
 */
export type StopCallRecordingRequest = Message<'com.gem.bff.contract.StopCallRecordingRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;

  /**
   * @generated from field: string recordingId = 2;
   */
  recordingId: string;
};

/**
 * Describes the message com.gem.bff.contract.StopCallRecordingRequest.
 * Use `create(StopCallRecordingRequestSchema)` to create a new message.
 */
export const StopCallRecordingRequestSchema: GenMessage<StopCallRecordingRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 9);

/**
 * @generated from message com.gem.bff.contract.GetCallPermissionsRequest
 */
export type GetCallPermissionsRequest =
  Message<'com.gem.bff.contract.GetCallPermissionsRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;
  };

/**
 * Describes the message com.gem.bff.contract.GetCallPermissionsRequest.
 * Use `create(GetCallPermissionsRequestSchema)` to create a new message.
 */
export const GetCallPermissionsRequestSchema: GenMessage<GetCallPermissionsRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 10);

/**
 * @generated from message com.gem.bff.contract.SetCallPermissionsForAllRequest
 */
export type SetCallPermissionsForAllRequest =
  Message<'com.gem.bff.contract.SetCallPermissionsForAllRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: com.gem.bff.contract.CallPermissions default = 2;
     */
    default?: CallPermissions;
  };

/**
 * Describes the message com.gem.bff.contract.SetCallPermissionsForAllRequest.
 * Use `create(SetCallPermissionsForAllRequestSchema)` to create a new message.
 */
export const SetCallPermissionsForAllRequestSchema: GenMessage<SetCallPermissionsForAllRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 11);

/**
 * @generated from message com.gem.bff.contract.SetCallPermissionsForMemberRequest
 */
export type SetCallPermissionsForMemberRequest =
  Message<'com.gem.bff.contract.SetCallPermissionsForMemberRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: int64 memberId = 2;
     */
    memberId: bigint;

    /**
     * @generated from field: com.gem.bff.contract.PersonalizedCallPermissions personalized = 3;
     */
    personalized?: PersonalizedCallPermissions;
  };

/**
 * Describes the message com.gem.bff.contract.SetCallPermissionsForMemberRequest.
 * Use `create(SetCallPermissionsForMemberRequestSchema)` to create a new message.
 */
export const SetCallPermissionsForMemberRequestSchema: GenMessage<SetCallPermissionsForMemberRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 12);

/**
 * @generated from message com.gem.bff.contract.ClearPermissionsForMemberRequest
 */
export type ClearPermissionsForMemberRequest =
  Message<'com.gem.bff.contract.ClearPermissionsForMemberRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: int64 memberId = 2;
     */
    memberId: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.ClearPermissionsForMemberRequest.
 * Use `create(ClearPermissionsForMemberRequestSchema)` to create a new message.
 */
export const ClearPermissionsForMemberRequestSchema: GenMessage<ClearPermissionsForMemberRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 13);

/**
 * @generated from message com.gem.bff.contract.CreatePermissionRequestRequest
 */
export type CreatePermissionRequestRequest =
  Message<'com.gem.bff.contract.CreatePermissionRequestRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: com.gem.bff.contract.CallPermission.AccessType access = 2;
     */
    access: CallPermission_AccessType;
  };

/**
 * Describes the message com.gem.bff.contract.CreatePermissionRequestRequest.
 * Use `create(CreatePermissionRequestRequestSchema)` to create a new message.
 */
export const CreatePermissionRequestRequestSchema: GenMessage<CreatePermissionRequestRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 14);

/**
 * @generated from message com.gem.bff.contract.GetPermissionRequestsRequest
 */
export type GetPermissionRequestsRequest =
  Message<'com.gem.bff.contract.GetPermissionRequestsRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;
  };

/**
 * Describes the message com.gem.bff.contract.GetPermissionRequestsRequest.
 * Use `create(GetPermissionRequestsRequestSchema)` to create a new message.
 */
export const GetPermissionRequestsRequestSchema: GenMessage<GetPermissionRequestsRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 15);

/**
 * @generated from message com.gem.bff.contract.UpdatePermissionRequestForMemberRequest
 */
export type UpdatePermissionRequestForMemberRequest =
  Message<'com.gem.bff.contract.UpdatePermissionRequestForMemberRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: int64 memberId = 2;
     */
    memberId: bigint;

    /**
     * @generated from field: com.gem.bff.contract.CallPermission.AccessType access = 3;
     */
    access: CallPermission_AccessType;

    /**
     * @generated from field: com.gem.bff.contract.CallPermission.RequestStatus status = 4;
     */
    status: CallPermission_RequestStatus;
  };

/**
 * Describes the message com.gem.bff.contract.UpdatePermissionRequestForMemberRequest.
 * Use `create(UpdatePermissionRequestForMemberRequestSchema)` to create a new message.
 */
export const UpdatePermissionRequestForMemberRequestSchema: GenMessage<UpdatePermissionRequestForMemberRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 16);

/**
 * @generated from message com.gem.bff.contract.UpdatePermissionRequestForAllRequest
 */
export type UpdatePermissionRequestForAllRequest =
  Message<'com.gem.bff.contract.UpdatePermissionRequestForAllRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: com.gem.bff.contract.CallPermission.RequestStatus status = 2;
     */
    status: CallPermission_RequestStatus;
  };

/**
 * Describes the message com.gem.bff.contract.UpdatePermissionRequestForAllRequest.
 * Use `create(UpdatePermissionRequestForAllRequestSchema)` to create a new message.
 */
export const UpdatePermissionRequestForAllRequestSchema: GenMessage<UpdatePermissionRequestForAllRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 17);

/**
 * @generated from message com.gem.bff.contract.AddMembersToCallRequest
 */
export type AddMembersToCallRequest = Message<'com.gem.bff.contract.AddMembersToCallRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;

  /**
   * @generated from field: repeated int64 memberIds = 2;
   */
  memberIds: bigint[];
};

/**
 * Describes the message com.gem.bff.contract.AddMembersToCallRequest.
 * Use `create(AddMembersToCallRequestSchema)` to create a new message.
 */
export const AddMembersToCallRequestSchema: GenMessage<AddMembersToCallRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 18);

/**
 * @generated from message com.gem.bff.contract.RemoveMembersFromCallRequest
 */
export type RemoveMembersFromCallRequest =
  Message<'com.gem.bff.contract.RemoveMembersFromCallRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: repeated int64 memberIds = 2;
     */
    memberIds: bigint[];
  };

/**
 * Describes the message com.gem.bff.contract.RemoveMembersFromCallRequest.
 * Use `create(RemoveMembersFromCallRequestSchema)` to create a new message.
 */
export const RemoveMembersFromCallRequestSchema: GenMessage<RemoveMembersFromCallRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 19);

/**
 * @generated from message com.gem.bff.contract.GetCallLinkRequest
 */
export type GetCallLinkRequest = Message<'com.gem.bff.contract.GetCallLinkRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;
};

/**
 * Describes the message com.gem.bff.contract.GetCallLinkRequest.
 * Use `create(GetCallLinkRequestSchema)` to create a new message.
 */
export const GetCallLinkRequestSchema: GenMessage<GetCallLinkRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 20);

/**
 * @generated from message com.gem.bff.contract.UpdateWaitingRoomForMemberRequest
 */
export type UpdateWaitingRoomForMemberRequest =
  Message<'com.gem.bff.contract.UpdateWaitingRoomForMemberRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: int64 memberId = 2;
     */
    memberId: bigint;

    /**
     * @generated from field: com.gem.bff.contract.UpdateWaitingRoomForMemberRequest.Status status = 3;
     */
    status: UpdateWaitingRoomForMemberRequest_Status;
  };

/**
 * Describes the message com.gem.bff.contract.UpdateWaitingRoomForMemberRequest.
 * Use `create(UpdateWaitingRoomForMemberRequestSchema)` to create a new message.
 */
export const UpdateWaitingRoomForMemberRequestSchema: GenMessage<UpdateWaitingRoomForMemberRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 21);

/**
 * @generated from enum com.gem.bff.contract.UpdateWaitingRoomForMemberRequest.Status
 */
export enum UpdateWaitingRoomForMemberRequest_Status {
  /**
   * @generated from enum value: APPROVE = 0;
   */
  APPROVE = 0,

  /**
   * @generated from enum value: REJECT = 1;
   */
  REJECT = 1,
}

/**
 * Describes the enum com.gem.bff.contract.UpdateWaitingRoomForMemberRequest.Status.
 */
export const UpdateWaitingRoomForMemberRequest_StatusSchema: GenEnum<UpdateWaitingRoomForMemberRequest_Status> =
  /*@__PURE__*/
  enumDesc(file_call_call_requests, 21, 0);

/**
 * @generated from message com.gem.bff.contract.UpdateWaitingRoomForAllRequest
 */
export type UpdateWaitingRoomForAllRequest =
  Message<'com.gem.bff.contract.UpdateWaitingRoomForAllRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: com.gem.bff.contract.UpdateWaitingRoomForAllRequest.Status status = 2;
     */
    status: UpdateWaitingRoomForAllRequest_Status;
  };

/**
 * Describes the message com.gem.bff.contract.UpdateWaitingRoomForAllRequest.
 * Use `create(UpdateWaitingRoomForAllRequestSchema)` to create a new message.
 */
export const UpdateWaitingRoomForAllRequestSchema: GenMessage<UpdateWaitingRoomForAllRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 22);

/**
 * @generated from enum com.gem.bff.contract.UpdateWaitingRoomForAllRequest.Status
 */
export enum UpdateWaitingRoomForAllRequest_Status {
  /**
   * @generated from enum value: APPROVE = 0;
   */
  APPROVE = 0,

  /**
   * @generated from enum value: REJECT = 1;
   */
  REJECT = 1,
}

/**
 * Describes the enum com.gem.bff.contract.UpdateWaitingRoomForAllRequest.Status.
 */
export const UpdateWaitingRoomForAllRequest_StatusSchema: GenEnum<UpdateWaitingRoomForAllRequest_Status> =
  /*@__PURE__*/
  enumDesc(file_call_call_requests, 22, 0);

/**
 * @generated from message com.gem.bff.contract.WaitingRoomAccessRequest
 */
export type WaitingRoomAccessRequest = Message<'com.gem.bff.contract.WaitingRoomAccessRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;

  /**
   * @generated from field: com.gem.bff.contract.WaitingRoomAccessRequest.Request request = 2;
   */
  request: WaitingRoomAccessRequest_Request;
};

/**
 * Describes the message com.gem.bff.contract.WaitingRoomAccessRequest.
 * Use `create(WaitingRoomAccessRequestSchema)` to create a new message.
 */
export const WaitingRoomAccessRequestSchema: GenMessage<WaitingRoomAccessRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 23);

/**
 * @generated from enum com.gem.bff.contract.WaitingRoomAccessRequest.Request
 */
export enum WaitingRoomAccessRequest_Request {
  /**
   * @generated from enum value: ASK_TO_JOIN = 0;
   */
  ASK_TO_JOIN = 0,

  /**
   * @generated from enum value: CANCEL = 1;
   */
  CANCEL = 1,
}

/**
 * Describes the enum com.gem.bff.contract.WaitingRoomAccessRequest.Request.
 */
export const WaitingRoomAccessRequest_RequestSchema: GenEnum<WaitingRoomAccessRequest_Request> =
  /*@__PURE__*/
  enumDesc(file_call_call_requests, 23, 0);

/**
 * @generated from message com.gem.bff.contract.CallPingRequest
 */
export type CallPingRequest = Message<'com.gem.bff.contract.CallPingRequest'> & {};

/**
 * Describes the message com.gem.bff.contract.CallPingRequest.
 * Use `create(CallPingRequestSchema)` to create a new message.
 */
export const CallPingRequestSchema: GenMessage<CallPingRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 24);

/**
 * @generated from message com.gem.bff.contract.SetCallParticipantsRolesRequest
 */
export type SetCallParticipantsRolesRequest =
  Message<'com.gem.bff.contract.SetCallParticipantsRolesRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: repeated com.gem.bff.contract.ParticipantIdToRole participantToRole = 2;
     */
    participantToRole: ParticipantIdToRole[];
  };

/**
 * Describes the message com.gem.bff.contract.SetCallParticipantsRolesRequest.
 * Use `create(SetCallParticipantsRolesRequestSchema)` to create a new message.
 */
export const SetCallParticipantsRolesRequestSchema: GenMessage<SetCallParticipantsRolesRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 25);
